import React from 'react';
import '../../styles/buttons/buttons.css';
import { Loader2 } from 'lucide-react';
import { Icon } from '@iconify/react/dist/iconify.js';
const PrimaryButton = ({onClick, href, text, isLoading=false, disabled=false, icon, style, className}) => {
  return (
    <a
      onClick={onClick}
      href={href}
      className={`button primary ${isLoading || disabled ? "button-disabled" : ""} ${className || ""}`}
      {...(isLoading || disabled ? { onClick: (e) => e.preventDefault() } : {})}
      style={style}
    >
      {isLoading ? (
        <div className="loader-container">
          <div className="loader">
            <div className="loader-inner"></div>
          </div>
        </div>
      ) : (
        <>
          <span>{text || "Continue"}</span>
          {icon && <Icon icon={icon} width="24" height="24"/>}
          
        </>
      )}
    </a>
  );
};


export default PrimaryButton